import { render, staticRenderFns } from "./ReportTplSetting.vue?vue&type=template&id=65b56689&scoped=true"
import script from "./ReportTplSetting.vue?vue&type=script&lang=js"
export * from "./ReportTplSetting.vue?vue&type=script&lang=js"
import style0 from "./ReportTplSetting.vue?vue&type=style&index=0&id=65b56689&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b56689",
  null
  
)

export default component.exports